module.exports = __webpack_public_path__ + "img/mobile/BetBar/btn-betland-up@2x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/BetBar/btn-betland-up@2x.png
// module id = 600
// module chunks = 0